import { render } from "./LeavePageConfirmation.vue?vue&type=template&id=24c542d8&scoped=true"
import script from "./LeavePageConfirmation.vue?vue&type=script&lang=js"
export * from "./LeavePageConfirmation.vue?vue&type=script&lang=js"

import "./LeavePageConfirmation.vue?vue&type=style&index=0&id=24c542d8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c542d8"]])

export default __exports__